import { render, staticRenderFns } from "./Updated.vue?vue&type=template&id=df2159e0&"
import script from "./Updated.vue?vue&type=script&lang=js&"
export * from "./Updated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports